// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"ef493af5","449":"c6c02dc8","470":"6d223e7d","488":"bc225099","661":"8957a882","717":"e0eb82b2"}[chunkId] + ".chunk.js";
};